import generate from 'nanoid/generate';

// ~35 years needed, in order to have a 1% probability of at least one collision, according to https://zelark.github.io/nano-id-cc/
const alphabet = '0123456789abcdefghijklmnopqrstuvwxyz';
const idLength = 12;

export default () => generate(alphabet, idLength);
